<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h5 class="mb-0 text-start fw-bold" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h5>
        </div>
        <div class="col text-end">
          <base-button tag="a" href="/systemUsers/new" type="primary" size="sm">{{ $t("Add New") }}</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class=" align-items-center table-flush text-start"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="tableData"
      >
        <template #columns>
          <th>{{ $t("Name") }}</th>
          <th>{{ $t("Email") }}</th>
          <th>{{ $t("Status") }}</th>
          <th>{{ $t("Date Created") }}</th>
          <th>{{ $t("Actions") }}</th>
        </template>

        <template #default="row">
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 font-size-sm fw-bolder">{{ row.item.name }}</span>
              </div>
            </div>
          </th>
          <td>
            <div class="name mb-0 font-size-sm">{{ row.item.email }}</div>
          </td>
          <td>
            <div class="badge p-1 font-size-sm" :class="row.item.status === 'active' ? 'bg-gradient-green' : 'bg-danger'">
              <span class="status">{{ $t(row.item.status) }}</span>
            </div>
          </td>
          <td>
              <div class="name mb-0 font-size-sm">{{ row.item.createdAt }}</div>
          </td>

          <td class="">
            <div class="btn-group" role="group" aria-label="">
              <base-button type="info" size="sm" @click="changeEmail(row.item)">{{ $t("Change email") }}</base-button>
              <base-button type="info" size="sm" @click="changePhoneNumber(row.item)">{{ $t("Change phone number") }}</base-button>
              <base-button tag="a" type="warning" :href="'/systemUser/'+row.item.id" class="fw-bold" size="sm">
                {{ $t("Edit") }}
              </base-button>
              <base-button type="success" class="bg-danger border-0" size="sm" @click="deleteUser(row.item.id)">
                {{ $t("Delete") }}
              </base-button>
            </div>
          </td>
        </template>
      </base-table>
      <update-auth v-model:modal-auth-update="updateAuth" v-model:auth-value="updateAuthValue" v-model:auth-id="updateAuthId" @on-close="onCloseAuthUpdate"></update-auth>
</div>

    <!--    <div-->
    <!--      class="card-footer d-flex justify-content-end"-->
    <!--      :class="type === 'dark' ? 'bg-transparent' : ''"-->
    <!--    >-->
    <!--      <base-pagination total="30"></base-pagination>-->
    <!--    </div>-->
  </div>
</template>
<script>
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import BaseButton from "@/components/BaseButton.vue"
import UpdateAuth from "@/components/UpdateAuth.vue"

export default {
  name: "system-users-table",
  components: {UpdateAuth, BaseButton},
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      updateAuth: "",
      updateAuthValue: "",
      updateAuthId: "",
      tableData: [],
    }
  },
  mounted() {
    this.getSystemAdmins()
  },
  methods: {
    onCloseAuthUpdate(updated){
      if (updated){
        this.getSystemAdmins()
      }
      this.updateAuthValue = ""
      this.updateAuth = ""
      this.updateAuthId = ""
    },
    changeEmail(user){
      this.updateAuthValue = user.email
      this.updateAuthId = user.id
      this.updateAuth = "email"
    },
    changePhoneNumber(user){
      this.updateAuthValue = user.phoneNumber
      this.updateAuthId = user.id
      this.updateAuth = "phoneNumber"
    },
    async getSystemAdmins() {
      await this.$store.dispatch("fetchSystemUsers").then((data) => {
        console.log("fetchSystemUsers", data)
        this.tableData = data
      })
    },
    deleteUser(id){
      this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        confirmButtonColor: "#dc3545",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          FirebaseFunctionsHelper.callFunction("system-removeUser", {id: id})
              .then((result) => {
                console.log("res", result)
                // eslint-disable-next-line no-prototype-builtins
                if (result != null && result.hasOwnProperty("message")) {
                  console.log("resmessage", result.message)
                  this.loadingProcess = "failed"
                  this.errorMessage = result.message
                  this.$swal.fire({
                    icon: "error",
                    html: result.message,
                    title: "Something went wrong!",
                  })
                  return
                }

                this.$swal.fire({
                  title: this.$t("Deleted!"),
                  html: this.$t("User removed."),
                  icon:"success",
                  timer: 1500,
                  timerProgressBar: true
                })
                this.getSystemAdmins()

              }, this)
              .catch((error) => {
                console.error("submitUser error", error)
                this.$swal.fire({
                  icon: "error",
                  html: result.message,
                  title: this.$t("Something went wrong!"),
                })
              })

        }
      })
    },
  },
}
</script>
<style></style>
